const Component = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="30"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M12.2537 5.16002L5.0137 0.980052C4.0867 0.444872 2.9448 0.444102 2.0172 0.978032C1.08949 1.51196 0.516552 2.4997 0.513672 3.57005V11.95C0.516552 13.0204 1.08949 14.0081 2.0172 14.5421C2.9448 15.076 4.0867 15.0752 5.0137 14.54L12.2537 10.36C13.1838 9.82462 13.757 8.83322 13.757 7.76002C13.757 6.68692 13.1838 5.69542 12.2537 5.16002Z"
        fill="white"
      />
    </svg>
  );
};

export default Component;
